import { useLanguage } from 'react-lib/dist/hooks-es';
import i18n from 'i18next';
import React from 'react';
import Connector from '../../../agent';
import { Dropdown, Icon } from 'semantic-ui-react';

type Props = {
  className: string;
};

const MobileChooseLanguage = ({ className }: Props) => {
  const { api } = Connector;

  const languageOptions = [
    { value: 'en', text: 'En' },
    { value: 'fr', text: 'Fr' },
  ];

  const [, setLanguage] = useLanguage(api, i18n);

  return (
    <div className={className}>
      <Dropdown pointing trigger={<Icon name="world" />}>
        <Dropdown.Menu>
          {languageOptions.map(singleLanguageDropdownItem(setLanguage))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MobileChooseLanguage;

function singleLanguageDropdownItem(setLanguage: (arg: string) => void) {
  return (language: { value: string; text: string }) => (
    <Dropdown.Item
      value={language.value}
      active={i18n.language === language.value}
      onClick={(e: any, data: { value: string }) => setLanguage(data.value)}
      content={language.text}
    />
  );
}
